import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchKomponenKegiatan } from "./api/get-komponen";
import { columns } from "./components/columns";
import { DataTable } from "@/components/ui/data-table";

export default function MasterDataKomponenKegiatan() {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["master-komponen-kegiatan"],
    queryFn: ({ pageParam }) => fetchKomponenKegiatan({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_next) {
        return allPages.length + 1;
      }
      return undefined;
    },
  });

  const komponenData = data?.pages.flatMap((page) => page.datas) || [];

  if (isLoading) {
    return <div className="p-6">Loading data komponen kegiatan...</div>;
  }

  if (isError) {
    return (
      <div className="p-6 text-red-500">Error: {(error as Error).message}</div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">
          Master Data Komponen Kegiatan
        </h1>
      </div>

      <div className="bg-card">
        <DataTable
          columns={columns}
          data={komponenData}
          onReachBottom={() => fetchNextPage()}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </div>
    </div>
  );
}
